import { useRef } from 'react';

// Import utilities
import { useProductPaymentStatus } from 'components/utilities';

// Import helpers
import { getButtonNameTranslation } from '../helpers';
import { convertCurrencyFormat as convertPrice } from 'helpers';
import { TRANSACTION_TYPES } from 'helpers/prices';

const { RENT, SUBSCRIPTION } = TRANSACTION_TYPES;

const usePriceButton = ({
	uuid,
	transactionType,
	vodSubType,
	promotion,
	price,
	setProductPayment,
	period,
	isPurchaseRedirect,
	productName,
	additionalText,
	buttonText
}) => {
	const ref = useRef();
	const { isPaymentPending, isLoading } = useProductPaymentStatus({
		uuid
	});

	const buttonNameTranslation = getButtonNameTranslation({
		transactionType,
		vodSubType
	});

	const convertedPrice = convertPrice(price).toFixed(2);
	const isPromotion = promotion && promotion.price !== null;
	const hasPeriod = !!(transactionType === RENT && period);
	const isSubscription = transactionType === SUBSCRIPTION;
	const isDisabled = isLoading || isPaymentPending;

	const handleSetProductPayment = () => {
		if (!isDisabled) {
			// Set product in payment context
			setProductPayment({
				price,
				period,
				productName,
				uuid,
				isPurchaseRedirect,
				promotion,
				transactionType
			});
		}
	};

	const commonButtonsProps = {
		additionalText,
		buttonText,
		promotion,
		period,
		buttonNameTranslation,
		convertedPrice,
		isPromotion,
		hasPeriod,
		isSubscription,
		isPaymentPending,
		isLoading
	};
	return {
		ref,
		handleSetProductPayment,
		commonButtonsProps,
		isDisabled
	};
};

export default usePriceButton;
